module.exports = "<style>#approveLog .u-grid-content{overflow-x:hidden;overflow-y:auto;height:364px}</style> <div id=approveLog> <div class=u-row style=min-height:364px> <u-grid params=\"config: config\"></u-grid> </div> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/components/modalrefer/approveLog/index.html
// module id = 194
// module chunks = 144